/** Homepoint's text line, the same number Caroline answers from. */
export const HOMEPOINT_SMS_NUMBER = '+12059730007';

/**
 * An `sms:` link to Homepoint's text line, optionally prefilled with a message.
 * The `?&body=` form is deliberate: iOS reads the body after `&`, Android after `?`,
 * and this spelling opens the composer prefilled on both.
 */
export const smsHref = (body?: string): string => {
  const base = `sms:${HOMEPOINT_SMS_NUMBER}`;
  return body ? `${base}?&body=${encodeURIComponent(body)}` : base;
};
